// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { TeamTypeWire } from '../mannequin/team-type-wire';


export class BattingOrderEventDataWire implements flatbuffers.IUnpackableObject<BattingOrderEventDataWireT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):BattingOrderEventDataWire {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsBattingOrderEventDataWire(bb:flatbuffers.ByteBuffer, obj?:BattingOrderEventDataWire):BattingOrderEventDataWire {
  return (obj || new BattingOrderEventDataWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsBattingOrderEventDataWire(bb:flatbuffers.ByteBuffer, obj?:BattingOrderEventDataWire):BattingOrderEventDataWire {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new BattingOrderEventDataWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

team():TeamTypeWire {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt8(this.bb_pos + offset) : TeamTypeWire.Home;
}

playerIds(index: number):number|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint32(this.bb!.__vector(this.bb_pos + offset) + index * 4) : 0;
}

playerIdsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

playerIdsArray():Uint32Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? new Uint32Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

static startBattingOrderEventDataWire(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addTeam(builder:flatbuffers.Builder, team:TeamTypeWire) {
  builder.addFieldInt8(0, team, TeamTypeWire.Home);
}

static addPlayerIds(builder:flatbuffers.Builder, playerIdsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, playerIdsOffset, 0);
}

static createPlayerIdsVector(builder:flatbuffers.Builder, data:number[]|Uint32Array):flatbuffers.Offset;
/**
 * @deprecated This Uint8Array overload will be removed in the future.
 */
static createPlayerIdsVector(builder:flatbuffers.Builder, data:number[]|Uint8Array):flatbuffers.Offset;
static createPlayerIdsVector(builder:flatbuffers.Builder, data:number[]|Uint32Array|Uint8Array):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt32(data[i]!);
  }
  return builder.endVector();
}

static startPlayerIdsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endBattingOrderEventDataWire(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createBattingOrderEventDataWire(builder:flatbuffers.Builder, team:TeamTypeWire, playerIdsOffset:flatbuffers.Offset):flatbuffers.Offset {
  BattingOrderEventDataWire.startBattingOrderEventDataWire(builder);
  BattingOrderEventDataWire.addTeam(builder, team);
  BattingOrderEventDataWire.addPlayerIds(builder, playerIdsOffset);
  return BattingOrderEventDataWire.endBattingOrderEventDataWire(builder);
}

unpack(): BattingOrderEventDataWireT {
  return new BattingOrderEventDataWireT(
    this.team(),
    this.bb!.createScalarList<number>(this.playerIds.bind(this), this.playerIdsLength())
  );
}


unpackTo(_o: BattingOrderEventDataWireT): void {
  _o.team = this.team();
  _o.playerIds = this.bb!.createScalarList<number>(this.playerIds.bind(this), this.playerIdsLength());
}
}

export class BattingOrderEventDataWireT implements flatbuffers.IGeneratedObject {
constructor(
  public team: TeamTypeWire = TeamTypeWire.Home,
  public playerIds: (number)[] = []
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const playerIds = BattingOrderEventDataWire.createPlayerIdsVector(builder, this.playerIds);

  return BattingOrderEventDataWire.createBattingOrderEventDataWire(builder,
    this.team,
    playerIds
  );
}
}
